import { render, staticRenderFns } from "./ChessDemand.vue?vue&type=template&id=f49c8990&scoped=true&"
import script from "./ChessDemand.vue?vue&type=script&lang=js&"
export * from "./ChessDemand.vue?vue&type=script&lang=js&"
import style0 from "./ChessDemand.vue?vue&type=style&index=0&id=f49c8990&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f49c8990",
  null
  
)

export default component.exports